<template>
    <div>
        <el-dialog title="Results of Trying Full Pattern"
                   :visible.sync="show_try_results"
                   :append-to-body="true"
        >
            <PatternTryResults
                    :results="try_results"
            />
        </el-dialog>
        <el-dialog title="Pattern Editor"
                   :visible.sync="show_pattern_dialog"
                   :append-to-body="true"
        >
            <PatternEditorStandard
                    :extentId="extentId"
                    @newPattern="newPattern"
                    @updatedPattern="updatedPattern"
                    :patternDefinition="selected_pattern_definition"
            />
        </el-dialog>
        <el-dialog title="Scope Editor"
                   :visible.sync="show_scope_dialog"
                   :append-to-body="true"
        >
            <ScopeEditorStandard
                    :extentId="extentId"
                    @newScope="newScope"
                    @updatedScope="updatedScope"
                    :scopeDefinition="selected_scope_definition"
            />
        </el-dialog>

        <div>
            Full Pattern Name <el-input v-model="name"></el-input>
        </div>
        <p style="margin-bottom:17px;margin-top:10px;">Note that the Full Pattern Name is reflected in multiple fields in the inventory.
            For example, if your pattern name is "Topic" (and you use the standard test)
            then you will have the following fields:
            "Topic 1", "Topic 2", "Topic 3", "Topic all", "Topic count", and "Has Topic".
            Keep this in mind when you name the pattern.</p>


        <div style="margin-bottom: 10px;">
            <div>Scope</div>
            <el-select filterable v-model="selected_scope" placeholder="Select scope to scrape from">
                <el-option
                        v-for="item2 in scopes"
                        :key = "item2.id"
                        :label = "item2.name"
                        :value = "item2.id">
                  <span>{{item2.name}}</span>
                  <el-tag type="info" size="mini" style="margin-left:20px;float:right;margin-top:7px;">{{ item2.type_tag }}</el-tag>
                </el-option>
            </el-select>
            <el-button  v-on:click="showScopeDialog">New Scope</el-button>
            <el-button v-if="selected_scope>=10000" v-on:click="showScopeDialog(true)">Edit Scope</el-button>
        </div>

        <div style="margin-bottom: 10px;">
            <div>Pattern</div>
            <el-select filterable v-model="selected_pattern" placeholder="Select pattern to scrape">
                <el-option
                        v-for="item in patterns"
                        :key = "item.id"
                        :label = "item.name"
                        :value = "item.id">
                  <span>{{item.name}}</span>
                  <el-tag type="info" size="mini" style="margin-left:20px;float:right;margin-top:7px;">{{ item.type_tag }}</el-tag>
                </el-option>
            </el-select>
            <el-button  v-on:click="showPatternDialog(false)">New Pattern</el-button>
            <el-button v-if="selected_pattern>=10000" v-on:click="showPatternDialog(true)">Edit Pattern</el-button>

        </div>

        <div style="margin-bottom: 10px;">
            <div>Test</div>
            <el-select filterable v-model="selected_test" placeholder="Select test (optional)">
                <el-option
                        v-for="item2 in tests"
                        :key = "item2.id"
                        :label = "item2.name"
                        :value = "item2.id">
                </el-option>
            </el-select>
        </div>
        <p style="margin-bottom:17px;">A full pattern consists of three components: 1) a scope (this is where to even look for the pattern,
            or, in the case of a simple HTML extraction, is actually the full pattern),
            2) a pattern (a regex), and 3) a test.</p>
        <div>
            <el-button @click="saveAndScrape">{{ btn_label_save_and_run }}</el-button>
            <el-button @click="save">{{ btn_label_save }}</el-button>
        </div>
        <div style="border-top: solid 1px;margin-top: 20px;">
            <p>You may wish to test your full pattern before saving.</p>
            <img v-if="awaiting_test_results" width="60" height="60" src="/images/icons/animated-progress-gear-computer-api.gif" />
            <el-button @click="tryUrl">Test Against:</el-button>
            URL <el-input v-model="url" style="width:50%;"></el-input>
            <div v-if="try_failed" style="margin-top: 20px;background-color:darkred;padding:20px;color:white;margin-bottom:40px;">
                Failed trying<span v-if="try_fail_text">: {{try_fail_text}}</span>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "FullPatternEditor",
        props: ['show_bleeding_edge','extentId','editedFullPattern'],
        mounted() {
            // console.log('Component mounted now.')
            this.getPatterns()
            this.getScopes()
            axios.get('/api/tests')
                .then(response => {
                    this.tests = response.data
                    // console.log(this.scopes)
                })
                .catch(error => {
                    console.log('oops getting tests')
                })
          this.setValuesFromFullPatternProp()
        },
        watch: {
          editedFullPattern: function (newValue, oldValue) {
            this.setValuesFromFullPatternProp()
          },
          selected_pattern: function (newValue, oldValue) {
            console.log('selected pattern changed')
            if (this.selected_pattern>=10000) {
              let found = false
              this.temp_patterns.forEach((pattern) => {
                    if (pattern.id === this.selected_pattern) {
                      found = true
                      this.selected_pattern_definition = pattern
                    }
                  })
              if (!found) {
                axios.get('/api/patterns/' + this.extentId + '/' + this.selected_pattern)
                    .then(response => {
                      console.log('loaded pattern')
                      this.selected_pattern_definition = response.data
                    })
                    .catch(error => {
                      console.log('oops loading pattern')
                    })
              }
            } else {
              console.log('low pattern id so not even trying to load -- setting to null')
              this.selected_pattern_definition = null
            }
          },
          selected_scope: function (newValue, oldValue) {
            console.log('selected scope changed')
            if (this.selected_scope>=10000) {
              let found = false
              this.temp_scopes.forEach((scope) => {
                if (scope.id === this.selected_scope) {
                  found = true
                  this.selected_scope_definition = scope
                }
              })
              if (!found) {
                axios.get('/api/scopes/' + this.extentId + '/' + this.selected_scope)
                    .then(response => {
                      console.log('loaded scope')
                      this.selected_scope_definition = response.data
                    })
                    .catch(error => {
                      console.log('oops loading scope')
                    })
              }
            } else {
              console.log('low scope id so not even trying to load -- setting to null')
              this.selected_scope_definition = null
            }
          }
        },
        methods: {
            setValuesFromFullPatternProp() {
              console.log('in setValuesFromFullPatternProp')
              console.log(this.editedFullPattern)
              if (this.editedFullPattern) {
                this.selected_pattern = this.editedFullPattern.pattern_id
                this.selected_scope = this.editedFullPattern.scope_id
                this.selected_test = this.editedFullPattern.test_id
                this.btn_label_save = "Update"
                this.btn_label_save_and_run = "Update and scrape now"
                this.btn_save_type = "update"
                this.name = this.editedFullPattern.name
              } else {
                this.selected_pattern = null
                this.selected_scope = null
                this.selected_test = 1
                this.btn_label_save = "Save"
                this.btn_label_save_and_run = "Save and scrape now"
                this.btn_save_type = "new"
                this.name = ''
              }
            },
            showPatternDialog(existing=false) {
                console.log('SHOW PATTERN DIALOG')
                console.log(existing)
                if (!existing) {
                  this.selected_pattern = null
                  this.selected_pattern_definition = null
                }
                this.show_pattern_dialog = true
            },
            showScopeDialog(existing=false) {
                if (!existing) {
                  this.selected_scope = null
                  this.selected_scope_definition = null
                }
                this.show_scope_dialog = true
            },
            getScopes() {
                axios.get('/api/scopes/' + this.extentId)
                    .then(response => {
                        this.scopes = response.data
                        // console.log(this.scopes)
                    })
                    .catch(error => {
                        console.log('oops loading scopes')
                    })
            },
            getPatterns() {
                axios.get('/api/patterns/' + this.extentId)
                    .then(response => {
                        this.patterns = response.data
                        // console.log(this.patterns)
                    })
                    .catch(error => {
                        console.log('oops loading patterns')
                    })
            },
            newPattern(pattern) {
                // this.getPatterns()
                this.selected_pattern = pattern.id
                this.selected_pattern_definition = pattern
                this.selected_pattern_definition.type_tag = 'unused'
                // in general the patterns list does NOT have the actual definition in them
                // (for instance, we don't want to show the actual pattern definitions in
                // the front end). We don't worry about pushing extra information
                // for these defined locally since these are custom ones they "own".
                this.patterns.push(pattern)
                // We keep a separate temp_patters since *all* of these will have
                // the full pattern definition, which we need access to when people
                // are selecting different patterns in the front end pulldown (in general
                // we make an API request to get the definitions, but since these temp
                // patterns aren't associated with this extent yet, we wouldn't get them
                // there
                this.temp_patterns.push(pattern)
                console.log(this.selected_pattern)
                this.show_pattern_dialog = false
            },
            updatedPattern(pattern) {
              // this.selected_pattern = pattern.id
              this.selected_pattern_definition = pattern
              this.patterns.forEach((p) => {
                if (p.id === pattern.id) p.name = pattern.name
              })
              this.temp_patterns = this.temp_patterns.filter(function(temp_pattern, index, arr){
                return temp_pattern.id !== pattern.id
              });
              this.temp_patterns.push(pattern)
              console.log(this.selected_pattern)
              this.show_pattern_dialog = false
            },
            newScope(scope) {
                console.log('hello')
                // this.getScopes()
                this.selected_scope = scope.id
                this.selected_scope_definition = scope
                this.selected_scope_definition.type_tag = 'unused'
                console.log('about to push the new scope in FullPatternEditor')
                console.log(this.scopes)
                this.scopes.push(scope)
                this.temp_scopes.push(scope)
                console.log(this.selected_scope)
                this.show_scope_dialog = false
            },
            updatedScope(scope) {
              this.selected_scope_definition = scope
              this.scopes.forEach((ps) => {
                if (ps.id === scope.id) s.name = scope.name
              })
              this.temp_scopes = this.temp_scopes.filter(function(temp_scope, index, arr){
                return temp_scope.id !== scope.id
              });
              this.temp_patterns.push(scope)
              console.log(this.selected_scope)
              this.show_scope_dialog = false
            },
            universalSave(event_name) {
              console.log('FullPatternEditor: in universalSave')
              console.log(event_name)
              let values = {}
              values.name = this.name
              values.pattern_id = this.selected_pattern
              values.scope_id = this.selected_scope
              values.test_id = this.selected_test
              if (this.editedFullPattern) {
                values.id = this.editedFullPattern.id
              } else {
                values.id = null
              }
              let request_type = 'post'
              if (this.btn_save_type==='update') {
                request_type = 'patch'
              }
              console.log(request_type)
              axios.request({
                method: request_type,
                url: `/api/fullpatterns/${this.extentId}`,
                data: { values }}).then(response => {
                values.id = response.data
                console.log(event_name)
                this.$emit(event_name, values)
              }).catch(error => {
                console.log('Could not save new full pattern')
                console.log(error.response)
              });
            },
            save() {
              console.log('FullPatternEditor: in save')
              console.log('FullPatternEditor save:' + this.btn_save_type)
              if (this.btn_save_type==='new') {
                this.universalSave('newFullPattern')
              } else {
                this.universalSave('updateFullPattern')
              }
            },
            saveAndScrape() {
              console.log('FullPatternEditor: saveAndScrape')
              console.log('FullPatternEditor saveAndScrape' + this.btn_save_type)
              if (this.btn_save_type==='new') {
                this.universalSave('newFullPatternAndScrape')
              } else {
                this.universalSave('updateFullPatternAndScrape')
              }
            },
            tryUrl() {
                this.awaiting_test_results = true
                this.try_failed = false
                axios.get('/api/fullpatterns/try_url?url=' + this.url +
                    '&pattern=' + this.selected_pattern +
                    '&scope=' + this.selected_scope +
                    '&test=' + this.selected_test
                )
                    .then(response => {
                        this.awaiting_test_results = false
                        this.try_results = response.data
                        if (this.try_results.instructions) {
                            this.try_fail_text = this.try_results.instructions
                            this.try_failed = true
                        } else {
                            this.show_try_results = true
                            this.try_failed = false
                        }
                        // console.log(this.scopes)
                    })
                    .catch(error => {
                        this.awaiting_test_results = false
                        this.try_failed = true
                        this.try_fail_text = error.response.data.message
                        console.log('error:')
                        console.log(error)
                        console.log('oops trying url pattern')
                    })
            }
        },
        data() {
            return {
                try_fail_text: '',
                try_failed: false,
                awaiting_test_results: false,
                name: null,
                selected_pattern: null,
                selected_pattern_definition: null,
                // if a new pattern is saved, it isn't associated to anything until
                // a full pattern is saved. This needs to be garbage collected in
                // the backend if it isn't used. That said, we need to keep track
                // of these in case there are many so they can switch through patterns
                // they are trying.
                temp_patterns: [],

                selected_scope: null,
                selected_scope_definition: null,
                temp_scopes: [],
                selected_test: 1,

                try_results: false,
                show_try_results: false,
                url: null,

                show_pattern_dialog: false,
                show_scope_dialog: false,
                show_pattern_try: false,

                patterns: [],
                scopes: [],
                tests: [],

                btn_label_save: "Save",
                btn_label_save_and_run: "Save & Scrape Full Pattern",
                btn_save_type: 'new'
            }
        }
    }
</script>

<style scoped>

</style>